import { Field } from 'react-final-form';

import { Box } from '@change-corgi/design-system-legacy/layout';

import { RichTextEditor } from 'src/app/shared/components/richTextEditor';
import { requiredValidatorWithNoMessage } from 'src/app/shared/form/validators';

import type { DescriptionTextAreaProps, PetitionUpdateFormValues } from '../../types';

import { EmbeddedMediaPreview } from './components/EmbeddedMediaPreview';
import { useDescriptionTextArea } from './hooks/useDescriptionTextArea';

export function DescriptionTextArea({ initialValue }: DescriptionTextAreaProps) {
	const {
		actions: { onDescriptionChange, trackFocus, onClosePreview, onFetchError, onFetchSuccess },
		data: { description, descriptiveLabel, label },
	} = useDescriptionTextArea();

	return (
		<Box mt={[24, 40]} mb={24} sx={{ width: '100%' }}>
			<Field<PetitionUpdateFormValues['description']>
				name="description"
				type="text"
				initialValue={initialValue}
				validate={requiredValidatorWithNoMessage}
			>
				{({ input: { onChange } }) => {
					return (
						<>
							<Box mb={4}>
								<label htmlFor="text-editor-id">{label}</label>
							</Box>
							<RichTextEditor
								data-testid="description"
								textEditorId="text-editor-id"
								initialValue={initialValue}
								descriptiveLabel={descriptiveLabel}
								onEditorChange={(descriptionInput) => onDescriptionChange(descriptionInput, onChange)}
								onEditorFocus={() => trackFocus()}
							/>
						</>
					);
				}}
			</Field>
			<EmbeddedMediaPreview
				value={description}
				onClosePreview={onClosePreview}
				onFetchError={onFetchError}
				onFetchSuccess={onFetchSuccess}
			/>
		</Box>
	);
}
